import { all, put, race, select, take, takeLatest } from 'redux-saga/effects'
import requestDataForEvents from '../../actions/bookingCalendar/event/requestDataForEvents'
import {
  searchIsReady,
  searchLoadingFailed,
} from '../../actions/search/loadSearch'
import { requestDataForUserSettings } from '../../actions/userObject/settings/requestFetchUserSettings'
import { EventActions } from '../../reducers/bookingCalendar/actionNames'
import { getIsFullyLoaded } from '../../reducers/bookingCalendar/selectors/dates'
import { SearchActions } from '../../reducers/search/actionNames'
import { isSearchReady } from '../../reducers/search/selectors/search'
import { UserSettingsActions } from '../../reducers/userObject/actionNames'
import { isSettingsAccepted } from '../../reducers/userObject/selectors/settings'

function* load() {
  const isReady = yield select(isSearchReady)
  if (isReady) yield put(searchIsReady())

  const requirements = [
    {
      condition: select(getIsFullyLoaded),
      load: put(requestDataForEvents()),
      take: race({
        done: take(EventActions.DataForEventsAccepted),
        fail: take(EventActions.DataForEventsRejected),
      }),
    },
    {
      condition: select(isSettingsAccepted),
      load: put(requestDataForUserSettings()),
      take: race({
        done: take(UserSettingsActions.DataForUserSettingsAccepted),
        fail: take(UserSettingsActions.DataForUserSettingsRejected),
      }),
    },
  ]

  try {
    const satisfied: boolean[] = yield all(requirements.map(r => r.condition))
    yield all(requirements.filter((_, i) => !satisfied[i]).map(r => r.load))
    const accepted = yield all(
      requirements.filter((_, i) => !satisfied[i]).map(r => r.take),
    )
    const success = accepted.reduce(
      (isSuccess, a) => isSuccess && !a.fail,
      true,
    )

    if (success) {
      yield put(searchIsReady())
    } else {
      yield put(searchLoadingFailed('Error'))
    }
  } catch (e) {
    yield put(searchLoadingFailed(e))
  }
}

export default function* () {
  yield takeLatest(SearchActions.LoadSearch, load)
}
